import { IDocApprovalService } from './IDocApprovalService';
import { of as observableOf, Observable } from 'rxjs';
import { HttpRequestService } from '../../http-request.service';
import { apiURLs, PREVILEGEKEY } from '../../../globalcontants';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DocumentApprovalEntity } from '../../../models/Transactions/DocumentApprovalEntity';
import { ValidationEntity } from '../../../models/Utilities/ValidationEntity';

@Injectable({
  providedIn: 'root'
})
export class DocApprovalService implements IDocApprovalService {
  constructor(private httpService: HttpRequestService) { }

  // GetOpenOrders(siteId: number, userId: number,
  //    deliveryDate: Date = null, selectedLocationIds: number[] = null,
  //     selectedSuppliersIds: number[] = null): Observable<DocumentApprovalEntity[]> {

  //   const entity = {
  //     'SiteId': siteId,
  //     'UserId': userId,
  //     'DeliveryDate': deliveryDate,
  //     'SelectedLocationIds': selectedLocationIds,
  //     'SelectedSuppliersIds': selectedSuppliersIds,
  //   };
  //   const  inputParams = {'entity': entity, APIKEY : PREVILEGEKEY.GetOpenOrders };
  //   return this.httpService.postHttpRequest(apiURLs.DocApprovalAPI.GetOpenOrders, inputParams);

  // }

  GetApprovalTransactions(entity: any): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.DocApprovalAPI.GetApprovalTransactions, entity);
  }

  ProcessApprovalTransactions(entity: any, clientURL: any): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.DocApprovalAPI.ProcessApprovalTransactions, entity);
  }

  // PostProcessOrders(entities: DocumentApprovalEntity[]): Observable<ValidationEntity> {
  //   return this.httpService.postHttpRequest(apiURLs.DocApprovalAPI.SaveProcessOrders, entities);
  // }
}
